
import { Component, Vue } from 'vue-property-decorator';

import { getUnableNum } from '@/services/http';

@Component({
  name: 'NavMenu'
})
export default class extends Vue {
  menus: any[] = [
    {
      title: '个人账户',
      isOpen: true,
      child: [
        {
          id: 1,
          title: '个人中心',
          link: '/user',
          name: 'user'
        },
        {
          id: 11,
          title: '优惠券',
          link: '/coupon',
          name: 'coupon'
        },
        {
          id: 2,
          title: '个人信息',
          link: '/userinfor',
          name: 'userInfor'
        },
        {
          id: 10,
          title: '消息通知',
          link: '/notifys',
          name: 'notifys'
        },
        {
          id: 3,
          title: '安全设置',
          link: '/securityset',
          name: 'securitySet'
        },
        {
          id: 4,
          title: '地址管理',
          link: '/address',
          name: 'address'
        }
      ]
    },
    {
      title: '交易管理',
      isOpen: true,
      child: [
        {
          id: 5,
          title: '我的订单',
          link: '/order-list',
          name: 'orderList'
        },
        // {
        //   id: 6,
        //   title: '评价晒单',
        //   link: '/evaluation-list',
        //   name: 'evaluationList'
        // },
        {
          id: 7,
          title: '售后服务',
          link: '/exchange-list',
          name: 'exchangeList'
        }
      ]
    },
    {
      title: '客户服务',
      isOpen: true,
      child: [
        {
          id: 8,
          title: '发票资质',
          link: '/invoice',
          name: 'invoice'
        }
        // {
        //   id: 9,
        //   title: '意见反馈',
        //   link: '/feedback',
        //   name: 'feedback'
        // }
      ]
    }
  ]

  name: string = ''

  unableNum: number = 0

  created() {
    if (
      this.$route.name === 'grade'
      || this.$route.name === 'integral'
      || this.$route.name === 'integralDetails'
    ) {
      this.name = 'user';
    } else {
      this.name = this.$route.name ? this.$route.name : '';
    }
    this.getUnableNum();
  }

  async getUnableNum() {
    const res: any = await getUnableNum({
      companyId: 1
    });
    if (res.data.code === 100) {
      this.unableNum = res.data.data;
    }
  }

  // @Watch('$route')
  // routechange() {
  //   this.name = String(this.$route.name);
  // }

  private changeChild(item: any) {
    this.$router.push(item.link);
    // if (item.name === 'orderList') {
    //   window.location.href = '/order-list';
    // }
  }
}
